import React from 'react'
import DashboardLayout from 'src/layouts/DashboardLayout'
import { dashboardRoutes } from './routes'
import checkAccess from '../components/CanUse'

const privateRouts = (props) => {
  const { user = {} } = props
  if (user.userId) {
    const routes = []
    const defaultRoutes = []

    dashboardRoutes?.forEach((item) => {
      const route = checkAccess(item, user)
      if (route) routes.push(route)
      if (route?.default) defaultRoutes.push({ ...route, path: '' })
    })

    return [{
      path: 'app',
      element: <DashboardLayout {...props} />,
      children: [...routes, ...defaultRoutes],
    }]
  }
  return []
}

export default privateRouts
